<template>
    <div :class="['contact-view', 'is-scroll-' + (isScrollDown ? 'down' : 'top'), {loaded: !loading}]" :key="$route.params.locale">
        <div class="scene-holder">
            <div
                :class="[
                    'grid',
                    `state-${state}`
                ]"
            />
            <canvas class="scene" ref="scene"/>
        </div>
        <transition
            :css="false"
            @enter="handleEnter"
            @leave="handleLeave"
        >
            <Intro ref="page" :page="page" v-if="state === 0" @locations="() => state = 1"/>
        </transition>
        <transition
            :css="false"
            @enter="handleEnter"
            @leave="handleLeave"
        >
            <Locations ref="page" :page="page" :busines-units="businesUnits" v-if="state === 1" @close="() => state = 0"/>
        </transition>
        <transition
            :css="false"
            @enter="handleEnter"
            @leave="handleLeave"
        >
            <Form  ref="page" :page="page" v-if="state === 2" @close="() => state = 1"/>
        </transition>
        <!-- <transition name="scroll-fade" :duration="{ enter: 1000, leave: 1000 }">
            <button v-if="state < 2" @click="state = 2" class="contact-link">
                {{page.contactform}}
            </button>
        </transition> -->
    </div>
</template>
<script>
import App from "@/views/Contact/app";
import Intro from '@/views/Contact/components/Intro'
import Locations from '@/views/Contact/components/Locations'
import Form from '@/views/Contact/components/Form'
import {locations} from '@/store/index.js'
import Wheel from '@/pure/Wheel'
import Drag from '@/pure/Drag'
import { getContact } from '@/store/api/index'
export default {
    name: 'contact',
    components: {
        Intro,
        Locations,
        Form
    },
    data() {
        return {
            state: 0,
            locations,
            businesUnits: [],
            page: {},
            loading: true,
            dataLoaded: false,
            isScrollDown: true
        }
    },
    watch: {
        state(state, oldState) {
            this.wheel.disable()
            this.isScrollDown = state > oldState
            this.app.setState(state)
            this.y = 0
        }
    },
    created() {
        getContact({
                lang: this.$route.params.locale
            })
            .then(({ countries, businessunits, page }) => {
                this.$set(this, 'page', page)
                this.$set(this, 'businesUnits', businessunits)
                locations.checkCountries(countries)
                this.$nextTick(() => {
                    this.loading = false
                    this.dataLoaded = true
                    this.app.earth.mapLocations(this.locations.data)
                })
            })
    },
    mounted() {
        this.app = new App({
            $el: this.$refs.scene
        })
        if(this.mobile) {
            this.y = 0
            this.wheel = new Drag({
                element: this.$el,
                // onDragCb: this.onDrag,
                onMoveCb: this.onDrag,
                // onDropCb: this.onDrop,
                // onSlideCb: this.onSlide
            })
            this.wheel.isEnable = true
        }
        else {
            this.wheel = new Wheel({
                pixelStep: 10,
                lineHeight: 40,
                pageHeight: 800,
                preventDefault: true,
                stopPropagation: true,
                // onTop: this.onTop,
                // onDown: this.onDown,
                onMove: this.onMove
            })
        }
        window.scroll(0, 0)
    },
    activated()
    {
        if(this.dataLoaded) {
            this.$nextTick(() => {
                this.loading = false
                this.wheel = new Wheel({
                    pixelStep: 10,
                    lineHeight: 40,
                    pageHeight: 800,
                    preventDefault: true,
                    stopPropagation: true,
                    // onTop: this.onTop,
                    // onDown: this.onDown,
                    onMove: this.onMove
                })
            })
        }
    },
    deactivated() {
    this.loading = true
        this.wheel.dispose()
    },
    beforeDestroy() {
        this.app.destroy()
        this.wheel.dispose()
    },
    methods: {
        handleEnter(el, done) {
            TweenMax.killTweensOf(el)
            TweenMax.set(el, {alpha: 0, y: this.isScrollDown ? 300 : -300})
            TweenMax.to(el, 1.0, {alpha: 1, y: 0, onComplete: () => {
                done()
                this.wheel.enable()
            }})
        },
        handleLeave(el, done) {
            TweenMax.killTweensOf(el)
            TweenMax.to(el, .3, {alpha: 0, y: this.isScrollDown ? -300 : 300, onComplete: done})
        },
        onTop() {
            this.state = Math.max(0, this.state - 1)
        },
        onDown() {
            this.state = Math.min(2, this.state + 1)
        },
        onDrag(x, y) {
            const newGrec = this.y + y
            if(this.wheel.isEnable && Math.abs(newGrec) > 100) {
                const newState = Math.min(Math.max(this.state - Math.sign(y), 0), 2)
                this.state = newState
            } else if(this.wheel.isEnable) {
                TweenMax.killTweensOf(this.$refs.page.$el)
                TweenMax.set(this.$refs.page.$el, {y: newGrec})
                this.y = newGrec
            }
        },
        onMove(y) {

            if(this.wheel.isEnable && Math.abs(y) > 50) {
                const newState = Math.min(Math.max(this.state + Math.sign(y), 0), 2)
                this.state = newState
            } else if(this.wheel.isEnable) {
                TweenMax.killTweensOf(this.$refs.page.$el)
                TweenMax.to(this.$refs.page.$el, .3, {y: (-1 ) * y})
            }

        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.contact-view
    width: 100%
    height: 100%
    overflow: hidden
    position: absolute
    top: 0
    left: 0
    touch-action: none
.contact-link
    color: #ff2b2a
    font-size: 20px
    font-weight: 500
    display: inline-block
    line-height: 67px
    height: 67px
    position: absolute
    right: 5.9375%
    margin-bottom: 5.7407407407vh
    bottom: 0
    cursor: pointer
    @include media-breakpoint-down($xl)
        font-size: 17px
    @media (max-height: 880px)
        font-size: 17px
    @include media-breakpoint-down($sm)
        font-size: 11px
        margin-bottom: 6.25%
    &:after
        content: ""
        position: relative
        display: inline-block
        width: 21px
        height: 2px
        background: #ff2b2a
        vertical-align: middle
        margin-left: 1em
        @include media-breakpoint-down($sm)
            display: none
.scene-holder
    position: absolute
    z-index: -5
    width: 100%
    height: 100%
    background-color: rgba(180,180,180,1)
.grid
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 150%
    z-index: -1
    background-image: url('./../../assets/cross.svg')
    background-position: 0 0
    background-size: 45px 45px
    opacity: 0.45
    will-change: transform
    transition: 1s cubic-bezier(.37,.01,.6,1)
    &.state-1
        transform: translateY(-12.5%)
    &.state-2
        transform: translateY(-25%)
// .scene
// .scroll-fade-enter-active, .scroll-fade-leave-active
//     transition: transform 1s cubic-bezier(.37,.01,.6,1)
//     will-change: transform
// .scroll-fade-enter, .is-scroll-down .scroll-fade-leave-to
//     transform: translateY(-100vh)
// .scroll-fade-leave-to, .is-scroll-down .scroll-fade-enter
//     transform: translateY(100vh)
</style>
